export default "__VITE_ASSET__Dwqw$5bY__"